import http from '@/api/common'

export default {
  getBuilding (buildingID) {
    return http.get(`building/get?id=${buildingID}`)
  },
  getBuildingsByLocation (params, locationID = null) {
    return http.get(`building/getbylocation?locationID=${locationID}`, { params })
  },
  createBuilding (building) {
    return http.post('building/create', building)
  },
  updateBuilding (building) {
    return http.post('building/update', building)
  },
  deleteBuilding (building) {
    return http.post('building/delete', building)
  },
  getChartDataByBuilding (buildingId) {
    return http.post(`building/getchartdatabybuilding?buildingId=${buildingId}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/buildings.js